// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 60 60"
    {...props}
  >
    <mask
      id="a"
      width={60}
      height={60}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path fill="#fff" d="M60 0H0V60H60V0Z" />
    </mask>
    <g mask="url(#a)">
      <path
        stroke="#6420B9"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={5.62}
        d="M22.5239 52.9707 37.5442 37.9785M37.5424 53.008 22.5259 38.0159"
      />
      <path
        fill="#6420B9"
        d="M45.9315 48.3186C44.3795 48.3186 43.1217 47.0607 43.1217 45.5088C43.1217 43.9568 44.3795 42.699 45.9315 42.699C50.5873 42.699 54.3609 38.9254 54.3609 34.2696C54.3609 31.7595 53.2576 29.5116 51.5164 27.9681C51.3366 27.8089 51.1502 27.6572 50.9573 27.5139C50.9451 27.5045 50.932 27.4951 50.9198 27.4858C50.7381 27.3509 50.5499 27.2254 50.3569 27.1055C50.3269 27.0868 50.297 27.069 50.267 27.0502C50.0881 26.9416 49.9036 26.8404 49.7163 26.7449C49.6648 26.7187 49.6123 26.6943 49.5599 26.67C49.3875 26.5866 49.2124 26.5089 49.0344 26.4368C48.9567 26.4059 48.8771 26.3796 48.7984 26.3506C48.6383 26.2925 48.4772 26.2354 48.3123 26.1867C48.2037 26.1549 48.0913 26.1286 47.9808 26.1015C47.8384 26.0649 47.697 26.0275 47.5527 25.9994C47.401 25.9694 47.2455 25.9507 47.091 25.9291C46.9795 25.9132 46.87 25.8926 46.7576 25.8823C46.486 25.8551 46.2106 25.8402 45.9315 25.8402C45.8434 25.8402 45.7582 25.8505 45.6711 25.8533C45.5859 25.3728 45.4782 24.9007 45.3508 24.4371C45.3189 24.3238 45.2777 24.2152 45.244 24.1028C45.1391 23.7515 45.0314 23.4022 44.9031 23.0613C44.8647 22.9582 44.8169 22.8608 44.7767 22.7578C44.638 22.4122 44.4947 22.0685 44.3336 21.7341C44.2943 21.6545 44.2494 21.5777 44.2091 21.4981C44.0321 21.1487 43.8494 20.8041 43.6481 20.4697C40.8692 15.8354 35.8087 12.7278 30.0093 12.7278C24.2099 12.7278 19.1494 15.8354 16.3705 20.4697C16.1691 20.8041 15.9865 21.1487 15.8095 21.4981C15.7692 21.5777 15.7243 21.6545 15.6849 21.7341C15.5238 22.0685 15.3805 22.4122 15.2419 22.7578C15.2016 22.8608 15.1539 22.9582 15.1155 23.0613C14.9872 23.4022 14.8794 23.7515 14.7745 24.1028C14.7418 24.2152 14.6996 24.3238 14.6678 24.4371C14.5404 24.9007 14.4327 25.3728 14.3475 25.8533C14.2604 25.8505 14.1751 25.8402 14.0871 25.8402C13.808 25.8402 13.5326 25.8551 13.261 25.8823C13.1486 25.8926 13.039 25.9132 12.9276 25.9291C12.773 25.9507 12.6176 25.9694 12.4658 25.9994C12.3216 26.0275 12.1802 26.0649 12.0378 26.1015C11.9273 26.1286 11.8149 26.1549 11.7062 26.1867C11.5414 26.2354 11.3803 26.2925 11.2202 26.3506C11.1415 26.3796 11.0619 26.4059 10.9841 26.4368C10.8062 26.5089 10.631 26.5866 10.4587 26.67C10.4062 26.6943 10.3538 26.7187 10.3023 26.7449C10.115 26.8404 9.93046 26.9416 9.75156 27.0502C9.72159 27.069 9.69162 27.0868 9.66165 27.1055C9.46871 27.2254 9.28045 27.3509 9.09875 27.4858C9.08658 27.4951 9.0744 27.5045 9.06129 27.5139C8.86835 27.6572 8.68197 27.8089 8.50214 27.9681C6.761 29.5116 5.65769 31.7595 5.65769 34.2696C5.65769 38.9254 9.43125 42.699 14.0871 42.699C15.639 42.699 16.8969 43.9568 16.8969 45.5088C16.8969 47.0607 15.639 48.3186 14.0871 48.3186C6.32829 48.3186 0.0380859 42.0283 0.0380859 34.2696C0.0380859 27.94 4.22469 22.592 9.97822 20.834C13.1055 12.8083 20.8756 7.10815 30.0093 7.10815C39.143 7.10815 46.913 12.8083 50.0403 20.834C55.7939 22.592 59.9805 27.94 59.9805 34.2696C59.9805 42.0283 53.6903 48.3186 45.9315 48.3186Z"
      />
    </g>
  </svg>
);
const IconUploadFailure = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconUploadFailure;
